/**
 * Coid 2.0 server
 * Coid 2.0 server API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Service code from the Service Registry
 */
export enum ServiceCode {
    ACCOUNT_OPEN = 'ACCOUNT_OPEN',
    ESIGN_ISSUANCE = 'ESIGN_ISSUANCE',
    LOAN_ISSUE = 'LOAN_ISSUE',
    CLIENT_REG = 'CLIENT_REG',
    CLIENT_UPD = 'CLIENT_UPD',
    AML_UPDATE = 'AML_UPDATE',
    INTERNAL_CONTROL = 'INTERNAL_CONTROL',
    ESIGN_DOCUMENT = 'ESIGN_DOCUMENT',
    OB_SERVICE = 'OB_SERVICE',
    OB_TAX = 'OB_TAX'
}

